document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cg-wrap').forEach(initGallery);
});

function initGallery(root) {
  var lightbox   = root.querySelector('[data-lightbox]');
  var stage      = root.querySelector('[data-lb-stage]');
  var slides     = Array.prototype.slice.call(root.querySelectorAll('[data-lb-slide]'));
  var currentEl  = root.querySelector('[data-lb-current]');
  var openBtns   = root.querySelectorAll('.cg-item-open');
  var prevBtn    = root.querySelector('[data-lb-prev]');
  var nextBtn    = root.querySelector('[data-lb-next]');
  var closeBtn   = root.querySelector('[data-lb-close]');

  var modal        = root.querySelector('[data-inquire-modal]');
  var modalClose    = root.querySelector('[data-inquire-close]');
  var pieceLabel    = root.querySelector('[data-inquire-piece]');
  var fieldTitle    = root.querySelector('[data-inquire-field-title]');
  var fieldBody     = root.querySelector('[data-inquire-field-body]');
  var form          = root.querySelector('.cg-form');

  var currentIndex = 0;

  /* ---------- Lightbox open/close ---------- */
  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      showSlide(parseInt(btn.getAttribute('data-index'), 10));
      openLightbox();
    });
  });

  function openLightbox() {
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  closeBtn && closeBtn.addEventListener('click', closeLightbox);
  lightbox && lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  function showSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    slides[currentIndex].classList.add('is-active');
    if (currentEl) currentEl.textContent = currentIndex + 1;
  }

  prevBtn && prevBtn.addEventListener('click', function () { showSlide(currentIndex - 1); });
  nextBtn && nextBtn.addEventListener('click', function () { showSlide(currentIndex + 1); });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'ArrowLeft') showSlide(currentIndex - 1);
    if (e.key === 'ArrowRight') showSlide(currentIndex + 1);
    if (e.key === 'Escape') closeLightbox();
  });

  /* ---------- Swipe support ---------- */
  var touchStartX = 0, touchEndX = 0;
  stage && stage.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  stage && stage.addEventListener('touchend', function (e) {
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchEndX - touchStartX;
    if (Math.abs(diff) > 40) {
      if (diff < 0) showSlide(currentIndex + 1);
      else showSlide(currentIndex - 1);
    }
  }, { passive: true });

  /* ---------- Inquire modal ---------- */
  root.querySelectorAll('[data-inquire]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var title = btn.getAttribute('data-title') || '';
      openInquire(title);
    });
  });

  function openInquire(title) {
    if (pieceLabel) pieceLabel.textContent = title ? ('Piece: ' + title) : '';
    if (fieldTitle) fieldTitle.value = title;
    if (fieldBody) fieldBody.value = 'I am interested in this piece' + (title ? (': ' + title) : '') + '.';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }
  function closeInquire() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
  modalClose && modalClose.addEventListener('click', closeInquire);
  modal && modal.addEventListener('click', function (e) {
    if (e.target === modal) closeInquire();
  });

  /* ---------- AJAX submit (still uses native Shopify /contact endpoint) ---------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('.cg-form-submit');
      var formData = new FormData(form);

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }

      fetch(form.action, { method: 'POST', body: formData })
        .then(function () {
          form.innerHTML = '<p class="cg-form-success">Thank you — your inquiry has been sent. Our team will contact you shortly.</p>';
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit Inquiry'; }
          alert('Something went wrong. Please try again or contact us directly.');
        });
    });
  }
}